import React from 'react';
import { applyAutoStretch } from 'components/report-content/components/dataset/index';

import IconMi from 'components/common/icon/IconMi';
import { Button } from '@mui/material';
import { ReportContentNS } from 'components/report-content/index';
import ComponentUpdateProps = ReportContentNS.ComponentUpdateProps;
import ComponentSettingsDataset = ReportContentNS.ComponentSettingsDataset;
import useBundleTranslation from 'i18n';

export default function ResetDatasetColumnsSize({
    component,
    updateBlockSettings,
}: ComponentUpdateProps<ComponentSettingsDataset>) {
    const { t } = useBundleTranslation();

    const handleClick = () => {
        updateBlockSettings(applyAutoStretch(component.settings, component.datasetRendererBlockComponentId));
    };

    return (
        <Button
            disabled={component.settings.autoStretch}
            variant="text"
            startIcon={<IconMi icon="columns" />}
            onClick={handleClick}
        >
            {t('reset_columns')}
        </Button>
    );
}
